import React from "react";
import { storyblokEditable } from "@storyblok/react";

const ServiceBigTextOnly = ({ blok }) => (
  <div className="wrap">
    <div className="servicebigtextonly-wrap inner-wrap" {...storyblokEditable(blok)}>
      <div className="servicebigtextonly-content">
              <h2 className="text-2xl merriweather">{blok.subheadline}</h2>
      </div>

    </div>
  </div>
  
);

export default ServiceBigTextOnly;
